import Swiper, { Navigation, Pagination } from 'swiper';

class AwardsSlider {
  constructor(el) {
    this.el = el;
    Swiper.use([Navigation, Pagination]);

    this.initSlider();
  }

  initSlider() {
    new Swiper(this.el.querySelector('.swiper'), {
      speed: 400,
      spaceBetween: 24,
      centeredSlides: false,
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }
}

export default AwardsSlider;
